<template>
  <div class="tab-bar">
    <div id="tab-bar-fixed" class="flex bg-white" style="position: fixed; width: 170px; flex-direction: column">
      <div v-for="(menu, idx) in menus" :key="'menu-'+idx" style="z-index: 999">
        <div class="unselect flex-align" :class="{
            'primary': menu.label === selectedMenu.label,
            'main': menu.label !== selectedMenu.label
          }" style="padding: 8px 12px; gap: 0 10px; height: 36px"
          @click="clickMenu(idx)">
          <div class="size-13 weight-700" style="flex: 1">{{ menu.label }}</div>
          <i class="material-icons" style="font-size: 16px">keyboard_arrow_{{ menu.label === selectedMenu.label ? 'up' : 'down' }}</i>
        </div>
        <div v-if="menu.label === selectedMenu.label" style="background-color: #f9f9f9; padding: 8px 0px 8px 10px">
          <template v-for="(child, ch_idx) in menu.child">
            <div v-if="child.isActive" :key="'child-'+ch_idx"
              class="unselect size-13" style="padding: 6px 12px"
              @click="clickChild(child)"
              :class="{
                'border-left-main main': child.menu_id === selectedItem.menu_id,
                'border-left-sub sub': child.menu_id !== selectedItem.menu_id
              }">{{ child.label }}</div>
          </template>
        </div>
      </div>
      <div class="bg-white" style="height: 100vh"></div>
    </div>
  </div>
</template>

<script>

export default {
  components: {

  },
  data () {
    return {
      menus: [
        {
          label: '상품 정보',
          child: []
        }
      ],
      selectedMenu: undefined,
      selectedItem: undefined
    }
  },
  computed: {
    prodPackage() {
      return this.$store.getters.prodPackage;
    },
    prodTab() {
      return this.$store.getters.prodTab;
    }
  },
  created(){
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      document.body.addEventListener('scroll', this.onScroll);
    })
  },
  beforeDestroy() {
    document.body.removeEventListener('scroll', this.onScroll);
  },
  watch: {
    prodPackage() {
      this.init();
    },
    prodTab() {
      this.selectMenu();
    },
    '$store.getters.routeHash'(n) {
      this.selectMenu();
      this.$router.replace({
        query: {
          id: this.$route.query.id
        },
        hash: n
      });
    },
  },
  methods:{
    init() {
      this.menus = [
        {
          label: '상품 정보',
          child: [
            {
              label: '카테고리',
              menu_id: 'sb_category',
              isActive: true
            },
            {
              label: '문의 전환, 결제방식',
              menu_id: 'sb_inquiry_conversion',
              isActive: true
            },
            {
              label: 'SNS 문의 전환',
              menu_id: 'sb_sns_inquiry',
              isActive: this.isInternalPlugin('sns_inquiry')
            },
            {
              label: '상품 기본정보',
              menu_id: 'sb_product_basic',
              isActive: true
            },
            {
              label: '수수료 설정',
              menu_id: 'sb_comm_type',
              isActive: true
            },
            {
              label: 'SEO 설정',
              menu_id: 'sb_seo',
              isActive: true
            },
            {
              label: '정책',
              menu_id: 'sb_policy',
              isActive: this.prodPackage === 'booking'
            },
            {
              label: '편의시설',
              menu_id: 'sb_convenience',
              isActive: this.prodPackage === 'booking'
            },
            {
              label: '위치',
              menu_id: 'sb_location',
              isActive: true
            },
            {
              label: '맞춤 DB',
              menu_id: 'sb_custom_db',
              isActive: true
            },
            {
              label: '예약 마감시간',
              menu_id: 'sb_reserve_deadline',
              isActive: this.prodPackage === 'reservation'
            },
            {
              label: '서비스 유형',
              menu_id: 'sb_reserve_policy',
              isActive: this.prodPackage === 'reservation'
            },
            {
              label: '가격정보',
              menu_id: 'sb_reserve_price',
              isActive: this.prodPackage === 'reservation'
            },
            {
              label: '상품옵션',
              menu_id: 'sb_product_option',
              isActive: this.prodPackage !== 'call'
            },
            {
              label: '상품 상세정보',
              menu_id: 'sb_product_detail',
              isActive: true
            },
            {
              label: '상품 공통 고시정보',
              menu_id: 'sb_product_common_info',
              isActive: true
            },
            {
              label: '관련상품',
              menu_id: 'sb_related_product',
              isActive: true
            },
            {
              label: '본인(성인)인증',
              menu_id: 'sb_verify',
              isActive: this.isInternalPlugin('age_verify') || this.isInternalPlugin('identity_verify')
            },
            {
              label: '포인트 적립',
              menu_id: 'sb_point_coupon',
              isActive: this.isInternalPlugin('point_coupon')
            },
          ]
        }
      ];

      // 숙박예약
      if (this.prodPackage === 'booking') {
        this.menus.push({
          label: '예약 일정/가격',
          child: [
            {
              label: '가격정보',
              menu_id: 'sb_price_info',
              isActive: true
            },
            {
              label: '일정',
              menu_id: 'sb_days',
              isActive: true
            },
          ]
        })
      }
      // 시간예약
      if (this.prodPackage === 'reservation') {
        this.menus.push({
          label: '일정',
          child: [
            {
              label: '일정',
              menu_id: 'sb_resv_days',
              isActive: true
            },
          ]
        })
      }
      this.selectMenu();
    },
    selectMenu() {
      this.selectedMenu = this.menus[this.prodTab];
      this.selectedItem = this.menus[this.prodTab].child.filter(i => i.isActive)[0];
    },
    onScroll() {
      let scrollTop = document.body.scrollTop;
      // sticky header 처리
      let fixed = false;
      let detector = document.getElementsByClassName('detector');
      if(detector.length === 0) {
        return;
      } else {
        detector = detector[0];
      }
      let sticky = document.getElementById('sticky');
      let nonSticky = document.getElementById('non-sticky');
      if (detector.getBoundingClientRect().top < 0) {
        fixed = true;
        sticky.style.display = 'block';
        nonSticky.style.display = 'none';
      } else {
        fixed = false;
        sticky.style.display = 'none';
        nonSticky.style.display = 'flex';
      }

      // tab-bar fixed
      let offset = scrollTop + document.getElementsByClassName('lp-footer')[0].getBoundingClientRect().top;
      let tabFixed = document.getElementById('tab-bar-fixed');
      if (offset - scrollTop < 500) {
        tabFixed.style.zIndex = 999
      } else {
        tabFixed.style.zIndex = 'auto'
      }

      // 스크롤 위치에 따라 tab-bar item selected 처리
      this.selectedMenu.child.filter(i => i.isActive).forEach(child => {
        let comp = document.getElementById(child.menu_id);
        if(comp){
          // 화면 높이 4등분
          //let windowHeight = (window.innerHeight/4).toFixed(0);
          let windowHeight = 168;
          let childOffset = comp.getBoundingClientRect().top;
          let gap = fixed ? -150 : -40
          // 범위 계산해서 범위 안에 들어오면 selectedItem으로 설정
          if(childOffset > gap && childOffset < windowHeight ) {
            this.selectedItem = child;
          }
        }
      })
    },
    clickMenu(idx) {
      this.$store.commit('setProdTab', idx);
    },
    clickChild(child) {
      this.selectedItem = child;
      location.replace(`#${child.menu_id}`);
    }
  }
}
</script>

<style lang="stylus" type="stylus" scoped>
@import '~assets/css/lp_main'

.tab-bar
  width 170px

.bg-white
  background-color white

.border-left-sub
  border-left 1px solid #dddddd

.border-left-main
  border-left 1px solid #363636

.main
  color #363636

.sub
  color #787878

</style>
